import { render, staticRenderFns } from "./PrinterDisplay.vue?vue&type=template&id=17b738f5&scoped=true&"
import script from "./PrinterDisplay.vue?vue&type=script&lang=js&"
export * from "./PrinterDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b738f5",
  null
  
)

export default component.exports